import { Dialog, DialogContent, withMobileDialog } from '@material-ui/core'
import React from 'react'

import { Text, Box } from './Base'

export const DialogButton = ({ disabled, children, isSimple, ml = 20, onClick }) => {
  return isSimple ? (
    <Box
      as="button"
      disabled={disabled}
      color={disabled ? 'thin' : 'text'}
      px={30}
      py="6px"
      className="btn is-outlined is-tiny"
      onClick={onClick}
    >
      {children}
    </Box>
  ) : (
    <Box
      ml={ml}
      as="button"
      onClick={onClick}
      className="btn is-tertiary is-tiny"
      disabled={disabled}
    >
      {children}
    </Box>
  )
}

const DialogModal = ({ fullScreen, open, title, actions, children, onClose, PaperProps }) => {
  return (
    <Dialog
      PaperProps={PaperProps}
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
    >
      <Text
        p={24}
        pb={12}
        as="h2"
        fontWeight="bold"
        id="form-dialog-title"
        fontSize={{ sm: '2.4rem', xs: '1.8rem' }}
        lineHeight={{ sm: '3.2rem', xs: '2.6rem' }}
        color="text"
      >
        {title}
      </Text>
      <DialogContent>{children}</DialogContent>
      <Box
        boxShadow={'0px 0px 30px 5px rgba(0,0,0,0.03);'}
        p={24}
        py={12}
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        className="fls"
      >
        {actions}
      </Box>
    </Dialog>
  )
}

export default withMobileDialog()(DialogModal)
